/* sp-bundle.js — bundle "Llevá 1/2/3" del kit Shopify maker (CONTRACTS §K.3, D-43; IIFE de bundle-block §1.10).
   Se carga con defer desde snippets/sp-bundle.liquid. Idempotente (flags globales) y sólo con delegación en document,
   así sobrevive a los re-renders del editor de temas sin re-inicializar.
   - Grupo ⇄ form por data-form-id: [data-sp-bundle] lleva el id del form de compra; la cantidad es el radio
     input[name="om-bundle"]:checked de ESE contenedor y se escribe en input[name="quantity"][form="<id>"] (los radios
     no son descendientes del form).
   - Parches de fetch y XMLHttpRequest (flags __omBundleFetchPatched / __omBundleXHRPatched): un POST a /cart/add del
     producto del bundle sale con quantity = radio elegido (body urlencoded: todas las quantity=; FormData o
     URLSearchParams: set). El grupo se identifica por el submit del form (captura) o por el id de variante del body;
     un add de otro producto no se toca, y un body JSON tampoco.
   - Despacha sp:bundle:change { qty, formId } en document al iniciar y al cambiar el radio.
   - Variantes (D-43): en variant:change recalcula cada opción con la fórmula del Liquid (total = unit × qty,
     disc = round(total × pct / 100), final = total − disc; pct de data-sp-pct) y actualiza data-sp-total,
     data-sp-final, data-unit-price y los textos con theme.Currency.formatMoney(cents, theme.settings.moneyFormat).
   - Opt-ins (2026-10-19): con data-sp-whole los textos van redondeados a unidades enteras (data-sp-final sigue con los
     centavos que cobra Shopify); con data-sp-strike="units" la opción 1 tacha el compare_at_price de la variante. */
(function () {
  'use strict';
  if (window.__spBundleInit) return;
  window.__spBundleInit = true;

  var GROUP = '[data-sp-bundle]';
  var RADIO = 'input[name="om-bundle"]';
  var CART_ADD_FORM = 'form[action*="/cart/add"]';
  var SUBMIT_WINDOW_MS = 1500;
  var pending = null; // { formId, at }: último submit de un form /cart/add (la request sale en ese mismo tick)
  var variantScope = null; // { el, id }: contenedor de la sección que despachó variantChange (captura)

  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function groups() { return toArray(document.querySelectorAll(GROUP)); }

  function groupByForm(formId) {
    if (!formId) return null;
    var all = groups();
    for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-form-id') === formId) return all[i];
    return null;
  }

  function formOf(group) {
    var id = group.getAttribute('data-form-id');
    return id ? document.getElementById(id) : null;
  }

  function qtyOf(group) {
    var radio = group && group.querySelector(RADIO + ':checked');
    var n = radio ? parseInt(radio.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  /** input[name="quantity"] del form del grupo: los asociados por form="<id>" y los descendientes del form. */
  function quantityInputs(group) {
    var id = group.getAttribute('data-form-id');
    var out = [];
    if (!id) return out;
    toArray(document.querySelectorAll('input[name="quantity"]')).forEach(function (input) {
      if (input.getAttribute('form') === id) out.push(input);
    });
    var form = document.getElementById(id);
    if (form) {
      toArray(form.querySelectorAll('input[name="quantity"]')).forEach(function (input) {
        if (out.indexOf(input) < 0) out.push(input);
      });
    }
    return out;
  }

  function syncQty(group) {
    var q = String(qtyOf(group));
    var inputs = quantityInputs(group);
    inputs.forEach(function (input) {
      if (input.value === q && input.getAttribute('value') === q) return;
      input.value = q;
      input.setAttribute('value', q);
      try {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) { /* navegadores sin constructor Event */ }
    });
    var form = formOf(group);
    if (form && !inputs.length) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'quantity';
      hidden.value = q;
      hidden.setAttribute('value', q);
      hidden.setAttribute('data-om-bundle-qty', '1');
      form.appendChild(hidden);
    }
  }

  /** Clase .active en la card elegida (respaldo del estado visual :has(input:checked) de 40-product.css). */
  function setActive(group) {
    toArray(group.querySelectorAll('.newpackbundlebox')).forEach(function (box) {
      var radio = box.querySelector(RADIO);
      box.classList.toggle('active', !!(radio && radio.checked));
    });
  }

  function emit(group) {
    try {
      document.dispatchEvent(new CustomEvent('sp:bundle:change', {
        detail: { qty: qtyOf(group), formId: group.getAttribute('data-form-id') }
      }));
    } catch (e) { /* sin CustomEvent: no hay a quién avisar */ }
  }

  function refresh(group) {
    setActive(group);
    syncQty(group);
    group.__spQty = qtyOf(group);
    emit(group);
  }

  /** Todos los grupos comparten name="om-bundle" (contrato heredado): elegir en uno puede desmarcar otro. */
  function refreshAll(changed) {
    groups().forEach(function (group) {
      if (group === changed || group.__spQty !== qtyOf(group)) refresh(group);
      else setActive(group);
    });
  }

  // ---------------------------------------------------------------- requests a /cart/add

  function isCartAdd(url) { return String(url || '').indexOf('/cart/add') > -1; }

  function variantIdOf(body) {
    try {
      if (typeof body === 'string') {
        var m = /(?:^|&)id=([^&]*)/.exec(body);
        return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
      }
      if (body && typeof body.get === 'function') {
        var v = body.get('id');
        return v == null ? null : String(v);
      }
    } catch (e) { /* body ilegible: no se identifica */ }
    return null;
  }

  function formVariantId(form) {
    var field = form && form.elements && form.elements.namedItem ? form.elements.namedItem('id') : null;
    return field && field.value != null ? String(field.value) : null;
  }

  /** Grupo de bundle al que pertenece un POST a /cart/add, o null (no se toca la request). */
  function groupForRequest(body) {
    if (!groups().length) return null;
    var id = variantIdOf(body);
    if (pending && Date.now() - pending.at < SUBMIT_WINDOW_MS) {
      // un submit = una request: se consume, y si el body trae otra variante no es la del form que se envió
      var sent = groupByForm(pending.formId);
      pending = null;
      if (!sent) return null;
      var fid = formVariantId(formOf(sent));
      return !id || !fid || id === fid ? sent : null;
    }
    if (!id) return null;
    var all = groups();
    for (var i = 0; i < all.length; i++) {
      if (formVariantId(formOf(all[i])) === id) return all[i];
    }
    return null;
  }

  function rewrite(body, qty) {
    var q = String(qty);
    if (typeof body === 'string') {
      var head = body.replace(/^\s+/, '').charAt(0);
      if (head === '{' || head === '[') return body; // JSON (/cart/add.js de apps): no es el form del tema
      if (/(^|&)quantity=/.test(body)) return body.replace(/(^|&)quantity=[^&]*/g, '$1quantity=' + q);
      return body + (body ? '&' : '') + 'quantity=' + q;
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) { body.set('quantity', q); return body; }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) { body.set('quantity', q); return body; }
    return body;
  }

  if (!window.__omBundleFetchPatched && typeof window.fetch === 'function') {
    window.__omBundleFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input, opts) {
      try {
        var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
        if (isCartAdd(url) && opts && opts.body) {
          var group = groupForRequest(opts.body);
          if (group) opts.body = rewrite(opts.body, qtyOf(group));
        }
      } catch (e) { /* nunca romper la compra por el parche */ }
      return origFetch.apply(window, arguments);
    };
  }

  if (!window.__omBundleXHRPatched && window.XMLHttpRequest) {
    window.__omBundleXHRPatched = true;
    var proto = window.XMLHttpRequest.prototype;
    var origOpen = proto.open;
    var origSend = proto.send;
    proto.open = function (method, url) {
      this.__spBundleUrl = url;
      return origOpen.apply(this, arguments);
    };
    proto.send = function (body) {
      var args = toArray(arguments);
      try {
        if (body && isCartAdd(this.__spBundleUrl)) {
          var group = groupForRequest(body);
          if (group) args[0] = rewrite(body, qtyOf(group));
        }
      } catch (e) { /* nunca romper la compra por el parche */ }
      return origSend.apply(this, args);
    };
  }

  // ---------------------------------------------------------------- eventos (delegación en document)

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(RADIO)) return;
    var group = t.closest(GROUP);
    if (group) refreshAll(group);
  });

  // captura: corre antes que el submit del tema (theme.AjaxProduct), que serializa el form y hace el fetch
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(CART_ADD_FORM)) return;
    pending = { formId: form.id || null, at: Date.now() };
    var group = groupByForm(form.id);
    if (group) syncQty(group);
  }, true);

  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[name="add"], button[type="submit"], [data-add-to-cart]');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!form || !form.matches(CART_ADD_FORM)) return;
    var group = groupByForm(form.id);
    if (group) syncQty(group);
  }, true);

  // ---------------------------------------------------------------- variantes (D-43)

  function money(cents) {
    var t = window.theme;
    if (t && t.Currency && typeof t.Currency.formatMoney === 'function') {
      return t.Currency.formatMoney(cents, t.settings && t.settings.moneyFormat);
    }
    return null;
  }

  // data-sp-whole (settings.sp_money_whole): los precios mostrados redondeados a unidades enteras de moneda (data-sp-final
  // sigue con los centavos que cobra Shopify); data-sp-strike="units": la opción 1 tacha el precio de comparación de la variante
  function shownCents(group, cents) {
    return group.hasAttribute('data-sp-whole') ? Math.round(cents / 100) * 100 : cents;
  }

  function recalc(group, unit, compare) {
    group.setAttribute('data-unit-price', String(unit));
    var strikeUnits = group.getAttribute('data-sp-strike') === 'units';
    var cmp = parseInt(compare, 10) || 0;
    toArray(group.querySelectorAll('[data-sp-tier]')).forEach(function (tier) {
      var qty = parseInt(tier.getAttribute('data-sp-tier'), 10) || 1;
      var pct = parseInt(tier.getAttribute('data-sp-pct'), 10) || 0;
      var total = unit * qty;
      var fin = total - Math.round(total * pct / 100);
      tier.setAttribute('data-sp-total', String(total));
      tier.setAttribute('data-sp-final', String(fin));
      var shownNew = money(shownCents(group, fin));
      var shownOld = pct > 0 ? money(shownCents(group, total)) : '';
      if (pct === 0 && strikeUnits) shownOld = cmp > unit ? money(cmp * qty) : '';
      var elNew = tier.querySelector('.bundlenewprice');
      var elOld = tier.querySelector('.bundleoldprice');
      if (elNew && shownNew !== null) elNew.textContent = shownNew;
      if (elOld && shownOld !== null) elOld.textContent = shownOld;
      // badge "Envío gratis" (setting free_from, en centavos): sólo si el total con descuento llega al mínimo
      var free = tier.querySelector('.sp-bb__free');
      if (free) {
        var from = parseInt(free.getAttribute('data-sp-free-from'), 10) || 0;
        free.hidden = !(from > 0 && fin >= from);
      }
    });
  }

  /** Miniaturas de las opciones = la foto de la variante elegida (si la tiene); sin foto no se toca nada (2026-10-18). */
  function rethumb(group, variant) {
    var img = variant && variant.featured_image && variant.featured_image.src;
    if (!img) return;
    var t = window.theme;
    var url = t && t.Images && typeof t.Images.getSizedImageUrl === 'function' ? t.Images.getSizedImageUrl(img, '240x') : img;
    toArray(group.querySelectorAll('.sp-bb__thumb img, .bundleglassicon > img')).forEach(function (el) {
      if (el.getAttribute('src') === url) return;
      el.removeAttribute('srcset');
      el.removeAttribute('sizes');
      el.setAttribute('src', url);
    });
  }

  /** ¿La variante es del producto del form del grupo? (sin form, se asume que sí) */
  function formHasVariant(group, id) {
    var form = formOf(group);
    if (!form) return true;
    var json = form.querySelector('[data-variant-json]');
    if (json) {
      try {
        var list = JSON.parse(json.value || json.textContent || '[]');
        for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return true;
        return false;
      } catch (e) { /* JSON ilegible: se mira el select */ }
    }
    var options = form.querySelectorAll('select[name="id"] option');
    if (!options.length) return true;
    for (var j = 0; j < options.length; j++) if (options[j].value === String(id)) return true;
    return false;
  }

  // theme.Variants despacha variantChange en el contenedor de la sección (no burbujea: se escucha en captura) y
  // enseguida variant:change en document; así el recálculo queda acotado a la sección que cambió.
  document.addEventListener('variantChange', function (e) {
    var v = e.detail && e.detail.variant;
    variantScope = v ? { el: e.target, id: String(v.id) } : null;
  }, true);

  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || v.price == null || isNaN(parseInt(v.price, 10))) return;
    var unit = parseInt(v.price, 10);
    var scope = variantScope && variantScope.id === String(v.id) && variantScope.el && variantScope.el.contains ? variantScope.el : null;
    variantScope = null;
    groups().forEach(function (group) {
      if (scope ? !scope.contains(group) : !formHasVariant(group, v.id)) return;
      recalc(group, unit, v.compare_at_price);
      rethumb(group, v);
    });
  });

  // ---------------------------------------------------------------- inicio y editor de temas

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = toArray(scope.querySelectorAll(GROUP));
    if (scope !== document && scope.matches && scope.matches(GROUP)) list.unshift(scope);
    list.forEach(refresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
